export enum TournamentFormEnum {
  Form11 = "11 vs 11",
  Form7 = "7 vs 7",
}
